import _ from 'lodash'
import core from '../../core'

const { helpers: { keepInLength, getLoginFromMail, getUserId } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const consequenceType = [
  { id: 1, label: 'Positive' },
  { id: 2, label: 'Negative' }
]

export const consequenceStatus = [
  { id: 1, label: 'Cancelled' },
  { id: 2, label: 'Completion Pending' },
  { id: 3, label: 'Completed' }
]

export const consequenceMandate = [
  { id: 1, label: 'Policy Mandated' },
  { id: 2, label: 'Not Policy Mandated' }
]

export const consequenceReasonA = [
  { id: 1, label: 'Act(s) of Acceptance' },
  { id: 2, label: 'Act(s) of Adaptablity' },
  { id: 3, label: 'Act(s) of Compassion' },
  { id: 4, label: 'Act(s) of Comradary' },
  { id: 5, label: 'Act(s) of Courage' },
  { id: 6, label: 'Act(s) of Dependability' },
  { id: 7, label: 'Act(s) of Determination' },
  { id: 8, label: 'Act(s) of Dilligence' },
  { id: 9, label: 'Act(s) of Forgiveness' },
  { id: 10, label: 'Act(s) of Gratitude' },
  { id: 11, label: 'Act(s) of Honesty' },
  { id: 12, label: 'Act(s) of Humility' },
  { id: 13, label: 'Act(s) of Impulse Control' },
  { id: 14, label: 'Act(s) of Kindness' },
  { id: 15, label: 'Act(s) of Leaership' },
  { id: 16, label: 'Act(s) of Optimism' },
  { id: 17, label: 'Act(s) of Patience' },
  { id: 18, label: 'Act(s) of Positivity' },
  { id: 19, label: 'Act(s) of Proactivity' },
  { id: 20, label: 'Act(s) of Self-discipline' },
  { id: 21, label: 'Being a Leader' },
  { id: 22, label: 'Being a Team Player' },
  { id: 23, label: 'Being Accepting' },
  { id: 24, label: 'Being Adaptable' },
  { id: 25, label: 'Being Compassionate' },
  { id: 26, label: 'Being Courageous' },
  { id: 27, label: 'Being Dependable' },
  { id: 28, label: 'Being Determined' },
  { id: 29, label: 'Being Dilligent' },
  { id: 30, label: 'Being Forgiving' },
  { id: 31, label: 'Being Grateful' },
  { id: 32, label: 'Being Honest' },
  { id: 33, label: 'Being Humble' },
  { id: 34, label: 'Being Kind' },
  { id: 35, label: 'Being Optimistic' },
  { id: 36, label: 'Being Patient' },
  { id: 37, label: 'Being Positive' },
  { id: 38, label: 'Being Proactive' },
  { id: 39, label: 'Being Self-Disciplined' },
  { id: 40, label: 'Being Self-Controlled' },
  { id: 41, label: 'Other' }
]

export const consequenceReasonB = [
  { id: 1, label: 'Abusive Language' },
  { id: 2, label: 'Aggression - Physical' },
  { id: 3, label: 'Aggression - Sexual' },
  { id: 4, label: 'Aggression - Verbal' },
  { id: 5, label: 'Bullying' },
  { id: 6, label: 'Centre Disruption' },
  { id: 7, label: 'Drug / Alcohol / Solvent Use' },
  { id: 8, label: 'Fire Setting' },
  { id: 9, label: 'Missing Curfew' },
  { id: 10, label: 'Missing Overnight' },
  { id: 11, label: 'Possession of Drug(s)' },
  { id: 12, label: 'Possession of Weapon(s)' },
  { id: 13, label: 'Potentially Unlawful Behaviour' },
  { id: 14, label: 'Property Damage' },
  { id: 15, label: 'Refusing to carry out Chores' },
  { id: 16, label: 'Refusing to complete Homework' },
  { id: 17, label: 'Refusing to go to Bed' },
  { id: 18, label: 'School / Course Refusal' },
  { id: 19, label: 'School / Course Truancy' },
  { id: 20, label: 'Setting off Burglar Alarm' },
  { id: 21, label: 'Setting off Fire Alarm' },
  { id: 22, label: 'Sexualised Behaviour' },
  { id: 23, label: 'Threatening Behaviour' },
  { id: 24, label: 'Verbal Aggression' },
  { id: 25, label: 'Violent Behaviour' },
  { id: 26, label: 'Other' }
]

export const valueTable = {
  consequenceType,
  consequenceStatus,
  consequenceMandate,
  consequenceReasonA,
  consequenceReasonB
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'consequence.date',
      'consequence.type',
      'consequence.reasonA',
      'consequence.reasonB',
      'consequence.mandate',
      'consequence.status',
      'consequence.validFrom',
      'consequence.notes'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'consequence.date',
    title: 'Consequence Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Consequence '
  },
  {
    name: 'consequence.time',
    title: 'Consequence Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Consequence '
  },
  {
    name: 'consequence.givenName',
    title: 'Consequence Given By Name(s)',
    formField: true,
    type: 'select',
    // getCellValue: row => console.log(personnel),
    // options: 'personnel', //FROM PERSONNEL REGISTER
    multiple: true,
    filterField: true,
    minSpace: 'Consequence Given '
  },
  {
    name: 'consequence.theirRoleGiven',
    title: 'Their Role(s)',
    formField: true,
    getCellValue: row => row[`consequence.givenName`] + ' - Role',
    //AUTO CALC BASE ON PERSONNEL ROLE & STATUS ROLE
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'consequence.type',
    title: 'Consequence Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(consequenceType, ['id', parseInt(row[`consequence.type`], 10)])
        ? _.find(consequenceType, ['id', parseInt(row[`consequence.type`], 10)])
            .label
        : row[`consequence.type`],
    options: 'consequenceType',
    filterField: true,
    minSpace: 'Consequence '
  },
  {
    name: 'consequence.reasonA',
    title: 'Reason Consequence Given',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(consequenceReasonA, [
        'id',
        parseInt(row[`consequence.reasonA`], 10)
      ])
        ? _.find(consequenceReasonA, [
            'id',
            parseInt(row[`consequence.reasonA`], 10)
          ]).label
        : row[`consequence.reasonA`],
    options: 'consequenceReasonA',
    filterField: true,
    minSpace: 'Consequence Given '
  },
  {
    name: 'consequence.reasonB',
    title: 'Reason Consequence Given',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(consequenceReasonB, [
        'id',
        parseInt(row[`consequence.reasonB`], 10)
      ])
        ? _.find(consequenceReasonB, [
            'id',
            parseInt(row[`consequence.reasonB`], 10)
          ]).label
        : row[`consequence.reasonB`],
    options: 'consequenceReasonB',
    filterField: true,
    minSpace: 'Consequence Given '
  },
  {
    name: 'consequence.mandate',
    title: 'Consequence Mandate',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(consequenceMandate, [
        'id',
        parseInt(row[`consequence.mandate`], 10)
      ])
        ? _.find(consequenceMandate, [
            'id',
            parseInt(row[`consequence.mandate`], 10)
          ]).label
        : row[`consequence.mandate`],
    options: 'consequenceMandate',
    filterField: true,
    minSpace: 'Consequence Mand'
  },
  {
    name: 'consequence.cancelledName',
    title: 'Consequence Cancelled By Name(s)',
    formField: true,
    type: 'select',
    // getCellValue: row => console.log(personnel),
    // options: 'personnel', //FROM PERSONNEL REGISTER
    multiple: true,
    filterField: true,
    minSpace: 'Cancelled By Name(s) '
  },
  {
    name: 'consequence.theirRoleCancelled',
    title: 'Their Role(s)',
    formField: true,
    getCellValue: row => row[`consequence.cancelledName`] + ' - Role',
    //AUTO CALC BASE ON PERSONNEL ROLE & STATUS ROLE
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'consequence.status',
    title: 'Consequence Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(consequenceStatus, ['id', parseInt(row[`consequence.status`], 10)])
        ? _.find(consequenceStatus, [
            'id',
            parseInt(row[`consequence.status`], 10)
          ]).label
        : row[`consequence.status`],
    options: 'consequenceStatus',
    filterField: true,
    minSpace: 'Consequence '
  },
  {
    name: 'consequence.validFrom',
    title: 'Consequence Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Consequence Status '
  },
  {
    name: 'consequence.notes',
    title: 'Consequence Notes',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Consequence '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'consequence',
      historyName: 'consequenceHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'con',
      activeName: 'consequence',
      historyName: 'consequenceHistory',
      label: 'Consequences',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.date',
            label: 'Consequence Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.time',
            label: 'Consequence Time',
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.givenName',
            label: 'Consequence Given By Name(s)',
            multiple: true,
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            // options: availableValues.personnel.filter(f => f.id > 0).map(o => {
            //   return { value: o.id, label: o.label }
            // })
            options: availableValues.users.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            })
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.theirRoleGiven',
            label: 'Their Role(s)',
            disabled: true,
            required: showAsterix
          }
        ],

        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'consequence.type',
          label: 'Consequence Type',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.consequenceType
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'consequence.reasonA',
          label: 'Reason Consequence Given',
          hidden:
            formValues &&
            formValues.consequence &&
            formValues.consequence.type !== 1,
          multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.consequenceReasonA
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'consequence.reasonB',
          label: 'Reason Consequence Given',
          hidden:
            formValues &&
            formValues.consequence &&
            formValues.consequence.type !== 1,
          multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.consequenceReasonB
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'consequence.mandate',
          label: 'Consequence Mandate',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.consequenceMandate
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.cancelledName',
            label: 'Consequence Cancelled By Name(s)',
            multiple: true,
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            // options: availableValues.personnel.filter(f => f.id > 0).map(o => {
            //   return { value: o.id, label: o.label }
            // })
            hidden:
              formValues &&
              formValues.consequence &&
              formValues.consequence.status !== 1,
            options: availableValues.users.filter(f => f.id > 0).map(o => {
              const label = `${o.firstName} ${o.lastName} (register: ${o.id})`
              return { value: o.id, label: label }
            })
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.theirRoleCancelled',
            label: 'Their Role(s)',
            disabled: true,
            required: showAsterix,
            hidden:
              formValues &&
              formValues.consequence &&
              formValues.consequence.status !== 1
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.status',
            label: 'Consequence Status',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.consequenceStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'consequence.validFrom',
            label: 'Consequence Status Valid at Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'consequence.notes',
          label: 'Consequence Notes',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['consequence']

export const errors = [1, 2]

export const defaultNew = {
  consequence: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  consequenceHistory: []
}

// "consequences": [
//   {
// "consequence": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "time": "T23:28:56.782Z",
//   "givenName": 1,
//   "theirRoleGiven" : 2,
//   "type": 1,
//   "reasonA": 2,
//   "reasonB": 3,
//   "mandate": 2,
//   "cancelledName" :2,
//   "theirRoleCancelled": 2,
//   "status": 1,
//   "validFrom": "2001-01-01T23:28:56.782Z",
//   "notes": "aaa"
// },
// "consequenceHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/consequences.js